export const jobRoles = [
  {
    "id": 9,
    "name": "Database Developer"
  },
      {
      "id": 48,
      "name": "Front End Developer"
    },
  {
    "id": 10,
    "name": "Data scientist"
  },
  {
    "id": 11,
    "name": "Database Engineer"
  },
{
    "id": 12,
    "name": "Database Analyst"
  },
  {
    "id": 13,
    "name": "Clinical Database Developer"
},
{
    "id": 14,
    "name": "Database Architect"
  },
  {
    "id": 15,
    "name": "Performance Database System Analyst"
  },
  {
    "id": 16,
    "name": "Database Analyst Advisor"
  },

  {
    "id": 17,
    "name": "Database Programmer Associate"
  },
{
    "id": 18,
    "name": "Data Architect"
},
{
    "id": 19,
    "name": "QA Tester"
  },
  {
    "id": 20,
    "name": "Quality Assurance"
  },
{
    "id": 22,
    "name": "SAP"
  },
  {
    "id": 24,
    "name": "SEO"
  },
{
  "id": 25,
  "name": "Full Stack Developer"
},   
{
    "id": 28,
    "name": "Cloud Ops"
},
{
    "id": 29,
    "name": "Meanstack Developer"
  },
  {
    "id": 30,
    "name": "Mern stack Developer"
  },
  {
    "id": 31,
    "name": "Other"
  },
  {
      "id": 32,
      "name": "Solution Architect"
  },
  {
    "id": 33,
    "name": "Support specialist"
  },
  {
    "id": 34,
    "name": "Mulesoft Developer"
  },
  {
    "id": 36,
    "name": "Salesforce Developer"
  },
{
    "id": 37,
    "name": "CloudOps/SRE"
},
{
    "id": 40,
    "name": "Data Engineer"
  },
  {
    "id": 41,
    "name": "Network Engineer"
  },
  {
      "id": 42,
      "name": "Sharepoint Developer"
    },
{
  "id": 43,
  "name": "Back End Developer"
},
{
    "id": 44,
    "name": "Cloud Database Engineer"
},
{
  "id": 45,
  "name": "Data analyst"
},
{
  "id": 46,
  "name": "Database Administrator"
},
{
  "id": 47,
  "name": "Data modeler"
},
{
  "id": 48,
  "name": "Engineering Management"
},
{
  "id": 49,
  "name": "Mobile Developer"
},
{
    "id": 54,
    "name": "Data Analysis"
},
{
    "id": 55,
    "name": "Data scientist"
},
{
    "id": 56,
    "name": "Blockchain Developer"
},
{
    "id": 57,
    "name": "Sheet1"
  },
{
    "id": 58,
    "name": "Project Management"
},
{
    "id": 59,
    "name": "Deep Learning"
},
{
    "id": 60,
    "name": "Low Level Systems/Embedded"
},
{
    "id": 61,
    "name": "Security Engineering"
},
{
    "id": 62,
    "name": "Business Analyst"
  },
  {
    "id": 63,
    "name": "UI/UX Designer"
  },
  {
    "id": 64,
    "name": "Low Code Developer"
  },
  {
    "id": 53,
    "name": "Product Management"
  },
   {
    "id": 68,
    "name": 'Project Manager '
  },
  {
    "id": 69,
    "name": 'Program Manager '
  }
]